export default "__VITE_ASSET__20f07824__"